"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectedFolderState = void 0;
/* eslint-disable react/display-name */
const react_1 = __importStar(require("react"));
const recoil_1 = require("recoil");
const folder_1 = require("../../../server/models/folder");
const react_i18next_1 = require("react-i18next");
const antd_1 = require("antd");
const core_1 = require("@material-ui/core");
const components_1 = require("@alcumus/components");
const foldersTreeDataState = (0, recoil_1.atom)({
    key: 'foldersTreeDataState',
    default: undefined,
});
exports.selectedFolderState = (0, recoil_1.atom)({
    key: 'selectedFolderState',
    default: undefined,
});
const useStyles = (0, core_1.makeStyles)(() => ({
    treeInput: {
        borderLeft: `4px solid ${components_1.StyleVariables.colors.border.critical}`,
        borderRadius: '8px',
        height: 40,
    },
}));
const FoldersTree = ({ visible, t }) => {
    const [selectedFolder, setSelectedFolder] = (0, recoil_1.useRecoilState)(exports.selectedFolderState);
    const [foldersData, setFoldersData] = (0, recoil_1.useRecoilState)(foldersTreeDataState);
    const [isLoadingData, setIsLoadingData] = (0, react_1.useState)(false);
    const isMounted = (0, react_1.useRef)(true);
    const classes = useStyles();
    const onChange = (value, label) => {
        setSelectedFolder({ value: value, label: label, key: value });
    };
    const createTreeForParent = (folders, rootId) => {
        const folderTree = [];
        for (let i = 0; i < folders.length; i++) {
            const treeData = {
                title: folders[i].name,
                value: folders[i].id,
                key: folders[i].id,
                children: [],
            };
            if (folders[i].parentId === rootId) {
                const children = createTreeForParent(folders, folders[i].id);
                if (children && children?.length > 0) {
                    treeData.children = children;
                }
                folderTree.push(treeData);
            }
        }
        return folderTree;
    };
    const createTree = (flatListFolders, rootFolderIds) => {
        const folderTree = [];
        if (!rootFolderIds) {
            rootFolderIds = flatListFolders
                .filter((folder) => !flatListFolders.find((x) => folder.parentId === x.id))
                .map((folder) => folder.parentId)
                .filter((folderId, index, folderIds) => folderIds.indexOf(folderId) === index);
        }
        rootFolderIds.forEach((rootId) => {
            const treeWithRootNodes = createTreeForParent(flatListFolders, rootId);
            treeWithRootNodes?.forEach((rootNode) => folderTree.push(rootNode));
        });
        return folderTree;
    };
    const getFolders = (0, react_1.useCallback)(() => {
        if (isMounted.current) {
            setIsLoadingData(true);
            (0, folder_1.getAllEditableFoldersFor)()
                .then((folders) => {
                if (folders) {
                    folders = folders.filter((folder) => folder.creatorId !== null);
                    const foldersAsTree = createTree(folders);
                    if (foldersAsTree) {
                        setFoldersData(foldersAsTree);
                    }
                }
            })
                .finally(() => {
                if (isMounted.current) {
                    setIsLoadingData(false);
                }
            });
        }
    }, [foldersData, setFoldersData, setSelectedFolder, visible]);
    (0, react_1.useEffect)(() => {
        getFolders();
        return () => {
            isMounted.current = false;
        };
    }, []);
    const defaults = {
        id: 'folderTreeSelector',
        bordered: true,
        onChange: onChange,
        placeholder: t('selectAFolder'),
        value: selectedFolder?.value,
        loading: isLoadingData,
        dropdownStyle: { maxHeight: 400, overflow: 'auto' },
        notFoundContent: (react_1.default.createElement("div", { className: 'p-20 text-center' }, t('noFoldersFound'))),
        treeIcon: () => {
            return react_1.default.createElement("i", { className: `fa fa-folder p-right10`, "aria-hidden": "true" });
        },
        treeData: foldersData,
    };
    return react_1.default.createElement(antd_1.TreeSelect, { ...defaults, className: classes.treeInput });
};
exports.default = (0, react_i18next_1.withTranslation)()(FoldersTree);
